"use strict";
/**
 * Label maps for UI display
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HAS_KIDS_FILTER_LABELS = exports.PRONOUNS_LABELS = exports.MAJOR_LABELS = exports.CAREER_FIELD_LABELS = exports.ZODIAC_SIGN_LABELS = exports.LANGUAGE_LABELS = exports.RELIGION_LABELS = exports.PET_TYPE_LABELS = exports.SEXUAL_ORIENTATION_LABELS = exports.SEXUAL_DYNAMICS_LABELS = exports.SEXUAL_ROLE_LABELS = exports.PREFERRED_STRUCTURE_LABELS = exports.INTERESTED_IN_LABELS = exports.FLEXIBILITY_LABELS = exports.RELATIONSHIP_INTENT_LABELS = exports.RELATIONSHIP_STRUCTURE_LABELS = exports.INCOME_RANGE_LABELS = exports.EMPLOYMENT_STATUS_LABELS = exports.EDUCATION_LEVEL_LABELS = exports.POLITICAL_VIEW_LABELS = exports.ETHNICITY_LABELS = exports.CUSTODY_LABELS = exports.CHILD_GENDER_LABELS = exports.WANTS_MORE_KIDS_LABELS = exports.HAS_KIDS_LABELS = exports.EXERCISE_LEVEL_LABELS = exports.FREQUENCY_LABELS = exports.BODY_TYPE_LABELS = void 0;
exports.BODY_TYPE_LABELS = {
    slim: 'Slim',
    athletic: 'Athletic',
    average: 'Average',
    curvy: 'Curvy',
    muscular: 'Muscular',
    stocky: 'Stocky',
    plus_size: 'Plus Size',
    pnta: 'Prefer not to answer',
};
exports.FREQUENCY_LABELS = {
    never: 'Never',
    rarely: 'Rarely',
    sometimes: 'Sometimes',
    often: 'Often',
    pnta: 'Prefer not to answer',
};
exports.EXERCISE_LEVEL_LABELS = {
    daily: 'Daily',
    often: '3-5x per week',
    sometimes: '1-2x per week',
    rarely: 'A few times a month',
    never: 'Never',
    pnta: 'Prefer not to answer',
};
exports.HAS_KIDS_LABELS = {
    no: 'No',
    yes: 'Yes',
    pnta: 'Prefer not to answer',
};
exports.WANTS_MORE_KIDS_LABELS = {
    no: 'No',
    someday: 'Someday',
    soon: 'Soon',
    not_sure: 'Not sure',
    pnta: 'Prefer not to answer',
};
exports.CHILD_GENDER_LABELS = {
    boy: 'Boy',
    girl: 'Girl',
    nonbinary: 'Non-binary',
    unspecified: 'Prefer not to answer',
};
exports.CUSTODY_LABELS = {
    full_time: 'Full time',
    half_time: 'Half time',
    occasional: 'Occasional',
    none: 'None',
    pnta: 'Prefer not to answer',
};
exports.ETHNICITY_LABELS = {
    asian: 'Asian',
    black: 'Black',
    hispanic_latino: 'Hispanic/Latino',
    white: 'White',
    middle_eastern: 'Middle Eastern',
    indigenous: 'Indigenous',
    mixed: 'Mixed',
    pnta: 'Prefer not to answer',
    other: 'Other',
};
exports.POLITICAL_VIEW_LABELS = {
    liberal: 'Liberal',
    moderate: 'Moderate',
    conservative: 'Conservative',
    apolitical: 'Apolitical',
    pnta: 'Prefer not to answer',
    other: 'Other',
};
exports.EDUCATION_LEVEL_LABELS = {
    high_school: 'High School',
    some_college: 'Some College',
    associates: 'Associates Degree',
    bachelors: "Bachelor's Degree",
    masters: "Master's Degree",
    doctorate: 'Doctorate',
    trade: 'Trade School',
    pnta: 'Prefer not to answer',
};
exports.EMPLOYMENT_STATUS_LABELS = {
    not_working: 'Not Working',
    student: 'Student',
    part_time: 'Part Time',
    full_time: 'Full Time',
    self_employed: 'Self Employed',
    pnta: 'Prefer not to answer',
};
exports.INCOME_RANGE_LABELS = {
    under_50k: 'Under $50k',
    '50k_100k': '$50k - $100k',
    '100k_200k': '$100k - $200k',
    '200k_plus': '$200k+',
    pnta: 'Prefer not to answer',
};
exports.RELATIONSHIP_STRUCTURE_LABELS = {
    monogamous: 'Monogamous',
    open_to_nonmonogamy: 'Open to non-monogamy',
    polyamorous: 'Polyamorous',
    pnta: 'Prefer not to answer',
};
exports.RELATIONSHIP_INTENT_LABELS = {
    friends: 'Friends',
    activity_partner: 'Activity Partner',
    dating: 'Dating',
    long_term: 'Long-term relationship',
    marriage: 'Marriage-oriented',
    casual: 'Casual',
    exploring: 'Exploring',
    hookup: 'Hookup',
    pnta: 'Prefer not to answer',
};
exports.FLEXIBILITY_LABELS = {
    yes: 'Yes',
    maybe: 'Maybe',
    no: 'No',
    pnta: 'Prefer not to answer',
};
exports.INTERESTED_IN_LABELS = {
    men: 'Men',
    women: 'Women',
    nonbinary: 'Non-binary people',
    pnta: 'Prefer not to answer',
};
exports.PREFERRED_STRUCTURE_LABELS = {
    monogamous_only: 'Monogamous only',
    open_to_nonmonogamy: 'Open to non-monogamy',
    polyamorous_only: 'Polyamorous only',
};
exports.SEXUAL_ROLE_LABELS = {
    top: 'Top',
    bottom: 'Bottom',
    side: 'Side',
    pnta: 'Prefer not to answer',
};
exports.SEXUAL_DYNAMICS_LABELS = {
    vanilla: 'Vanilla',
    kink_friendly: 'Kink Friendly',
    dominant: 'Dominant',
    submissive: 'Submissive',
    switch: 'Switch',
    exploring: 'Exploring',
    pnta: 'Prefer not to answer',
};
exports.SEXUAL_ORIENTATION_LABELS = {
    straight: 'Straight',
    gay: 'Gay',
    lesbian: 'Lesbian',
    bisexual: 'Bisexual',
    pansexual: 'Pansexual',
    queer: 'Queer',
    questioning: 'Questioning',
    asexual: 'Asexual',
    demisexual: 'Demisexual',
    heteroflexible: 'Heteroflexible',
    homoflexible: 'Homoflexible',
    fluid: 'Fluid',
    pnta: 'Prefer not to answer',
};
exports.PET_TYPE_LABELS = {
    dog: 'Dog',
    cat: 'Cat',
    fish: 'Fish',
    bird: 'Bird',
    reptile: 'Reptile',
    small_animal: 'Small animal',
    none: 'No pets',
    pnta: 'Prefer not to answer',
};
exports.RELIGION_LABELS = {
    agnostic: 'Agnostic',
    atheist: 'Atheist',
    buddhist: 'Buddhist',
    catholic: 'Catholic',
    christian: 'Christian',
    hindu: 'Hindu',
    jewish: 'Jewish',
    muslim: 'Muslim',
    sikh: 'Sikh',
    spiritual: 'Spiritual but not religious',
    protestant: 'Protestant',
    orthodox: 'Orthodox Christian',
    latter_day_saints: 'Latter-day Saints',
    none: 'None',
    pnta: 'Prefer not to answer',
    other: 'Other',
};
exports.LANGUAGE_LABELS = {
    english: 'English',
    spanish: 'Spanish',
    french: 'French',
    german: 'German',
    portuguese: 'Portuguese',
    chinese_mandarin: 'Mandarin',
    chinese_cantonese: 'Cantonese',
    japanese: 'Japanese',
    korean: 'Korean',
    arabic: 'Arabic',
    hindi: 'Hindi',
    russian: 'Russian',
    italian: 'Italian',
    vietnamese: 'Vietnamese',
    tagalog: 'Tagalog',
    polish: 'Polish',
    swahili: 'Swahili',
    asl: 'ASL',
    pnta: 'Prefer not to answer',
};
exports.ZODIAC_SIGN_LABELS = {
    aries: 'Aries',
    taurus: 'Taurus',
    gemini: 'Gemini',
    cancer: 'Cancer',
    leo: 'Leo',
    virgo: 'Virgo',
    libra: 'Libra',
    scorpio: 'Scorpio',
    sagittarius: 'Sagittarius',
    capricorn: 'Capricorn',
    aquarius: 'Aquarius',
    pisces: 'Pisces',
    pnta: 'Prefer not to answer',
};
exports.CAREER_FIELD_LABELS = {
    finance: 'Finance',
    tech: 'Technology',
    healthcare: 'Healthcare',
    education: 'Education',
    legal: 'Legal',
    marketing: 'Marketing',
    sales: 'Sales',
    engineering: 'Engineering',
    consulting: 'Consulting',
    government: 'Government',
    nonprofit: 'Nonprofit',
    arts_entertainment: 'Arts & Entertainment',
    hospitality: 'Hospitality',
    retail: 'Retail',
    construction: 'Construction',
    manufacturing: 'Manufacturing',
    real_estate: 'Real Estate',
    pnta: 'Prefer not to answer',
    other: 'Other',
};
exports.MAJOR_LABELS = {
    business: 'Business',
    computer_science: 'Computer Science',
    engineering: 'Engineering',
    biology: 'Biology',
    psychology: 'Psychology',
    communications: 'Communications',
    nursing: 'Nursing',
    education: 'Education',
    english: 'English',
    political_science: 'Political Science',
    economics: 'Economics',
    art_design: 'Art & Design',
    music: 'Music',
    pre_med: 'Pre-Med',
    pre_law: 'Pre-Law',
    undeclared: 'Undeclared',
    pnta: 'Prefer not to answer',
    other: 'Other',
};
exports.PRONOUNS_LABELS = {
    she_her: 'She/Her',
    he_him: 'He/Him',
    they_them: 'They/Them',
    any_pronouns: 'Any pronouns',
    custom: 'Other',
    pnta: 'Prefer not to answer',
};
exports.HAS_KIDS_FILTER_LABELS = {
    must_have: 'Has kids',
    must_not_have: "Doesn't have kids",
    either: 'No preference',
};
